module.exports = __webpack_public_path__ + "static/media/file-generic.d9bf5671.svg";